module.exports = __webpack_public_path__ + "media/images/front/icon_info-6bddc634e6ecde8dd1a0d42b8ad9d0fd.png";